module.exports = __webpack_public_path__ + "img/6.155e8552.png";